import { Country } from '../../models/Country';
import { State } from '../../models/State';
import { Store } from '../../models/Store';
import { aetherApi } from './aetherApi';

const advanceApi = aetherApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<Country[], void>({
      query: () => ({
        url: `api/v1/advance/countries`,
      }),
      transformResponse: (countries: { CountryName: string; isoCode: string }[]) =>
        countries.map((c) => ({ name: c.CountryName, code: c.isoCode })),
    }),
    getStates: builder.query<State[], string>({
      query: (country) => ({
        url: `api/v1/advance/countries/${country}/states`,
      }),
      transformResponse: (states: { state: string; stateCode: string }[]) =>
        states.map((s) => ({ name: s.state, code: s.stateCode })),
    }),
    getStoreDetails: builder.query<Store, void>({
      query: () => 'api/v1/advance/gateway/store-details',
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useGetStatesQuery,
  useLazyGetStatesQuery,
  useLazyGetStoreDetailsQuery,
} = advanceApi;
